import React from 'react';
import { Flex } from '../Flex';
import { Spinner } from '../Spinner';
import * as styles from './BaseButton.styles';
export function LoadingOverlay(_ref) {
  var _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  if (!isLoading) return null;
  return /*#__PURE__*/React.createElement(Flex, {
    "aria-hidden": "true",
    className: styles.LoadingOverlay,
    justify: "center"
  }, /*#__PURE__*/React.createElement(Spinner, {
    color: 'currentColor'
  }));
}
export default LoadingOverlay;